export const SEARCH_REGISTRATION_VALUE = "SEARCH_REGISTRATION_VALUE";
export const SEARCH_SPEAKER_VALUE = "SEARCH_SPEAKER_VALUE";
